import moment from "moment";
import {Tooltip} from "antd";
import {ArrowRightOutlined} from "@ant-design/icons";
import BrowserRouter, {BrowserRoutes} from "../../../routes/BrowserRouter";
import {IContract} from "../../../api/Contract/Contract.types";
import Button from "../../common/Button/Button";
import NumbersUtil from "../../../global/utils/number";

export const ContractsTableConfig = () => {
    return [
        {
            title: 'PIID', dataIndex: 'piid', key: 'piid',
            render: (piid) => {
                return (
                    <Tooltip title={piid}>
                        {piid}
                    </Tooltip>
                )
            }
        },
        {
            title: 'Awarded Date', width: 135, dataIndex: 'signedDate', key: 'signedDate',
            render: awardedDate => {
                if (awardedDate) {
                    return moment(awardedDate).format("MMM DD, YYYY")
                } else {
                    return null;
                }
            }
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            ellipsis: {showTitle: false},
            width: 200,
            render: description => {
                return (
                    <Tooltip title={description} placement="left">
                        {description}
                    </Tooltip>
                )
            }
        },
        {
            title: 'Solicitation Procedures', width: 250, dataIndex: 'solicitationProcedures', key: 'solicitationProcedures',
             ellipsis: {showTitle: false}, render: solicitationProcedures => {
                return (
                    <Tooltip title={solicitationProcedures} placement="left">
                        {solicitationProcedures}
                    </Tooltip>
                )
            }
        },
        {
            title: 'Obligated Amount', width: 180, dataIndex: 'obligatedAmount', key: 'obligatedAmount',
            render: obligatedAmount => {
                if (obligatedAmount) {
                    return "$" + NumbersUtil.toShortened(obligatedAmount, 2)
                } else {
                    return null;
                }
            }
        },
        {
            title: 'NAICS', width: 100, dataIndex: 'naics', key: 'naics',
        },
        {
            title: 'PSC', width: 100, dataIndex: 'pscAssociated', key: 'pscAssociated',
        },
        {
            title: 'State', width: 75, dataIndex: 'popState', key: 'popState'
        },
        {
            key: 'actions', render: (contract: IContract) => {
                return (
                    <div className='table-row-actions'>
                        <Button icon={<ArrowRightOutlined/>} iconPosition="right" onClick={() => BrowserRouter.push(BrowserRoutes.getContractsById(contract.id))}>
                            Details
                        </Button>
                    </div>
                )
            }
        }

    ]
}